import { reverseTranslateSegments, translateSegments } from "../../i18n/translateHelpers";

export function translateHrefWithLocale(href, locale) {
    const gotSearchParams = href.includes('?');
    const safeLocale = locale || 'nl-NL';
    const [lang] = safeLocale.split('-');

    // Extract anchor (hash) if present and work with the href without it
    const hashIndex = href.indexOf('#');
    const anchor = hashIndex !== -1 ? href.slice(hashIndex) : '';
    const hrefWithoutHash = hashIndex !== -1 ? href.slice(0, hashIndex) : href;

    if (gotSearchParams) {
        const [path, search] = hrefWithoutHash.split('?');
        const canonicalPath = reverseTranslateSegments(path, lang);
        const translated = translateSegments(canonicalPath, lang);

        return `/${safeLocale}${translated}?${search}${anchor}`;
    }else{
        const canonicalPath = reverseTranslateSegments(hrefWithoutHash, lang);
        const translated = translateSegments(canonicalPath, lang);

        return `/${safeLocale}${translated}${anchor}`;
    }

}
